module.exports = __webpack_public_path__ + "img/opel.2d46a20b.svg";